import { FC } from 'react'
import Stamp from '../../types/api/stamp'
import { Num, Root } from './elements/elements'
import StampTubeLabelInfo from './stamp-tube-label-info'

interface StampTubeLabelViewProps {
    stamp: Stamp | null
}

const StampTubeLabelView: FC<StampTubeLabelViewProps> = ({ stamp }) => {
    return (
        <Root>
            <Num value={stamp?.number || ''} onChange={() => {}} />
            <StampTubeLabelInfo stamp={stamp} />
        </Root>
    )
}

export default StampTubeLabelView
